import { AxiosError } from 'axios'

import { api } from '../libs/axios'

export interface Log {
  id: string
  action: string
  resource: string
  resource_id: string
  changes: object
  timestamp: Date
  file?: string | null
  user: {
    id: string
    name: string
    email: string
    phone: string
    avatar_url: string
  }
}

export interface GetLogsRequest {
  page?: number
  name?: string
  resource_id?: string
  resource?: string
  action?: string
}

interface GetLogsResponse {
  logs: Log[]
  totalCount: number
  pageQty: number
}

export async function getLogs(
  searchParams: GetLogsRequest,
): Promise<GetLogsResponse> {
  try {
    const params: { [key: string]: string | boolean } = {}

    Object.entries(searchParams).forEach(([key, value]) => {
      const param = key.replace(/([a-z])([A-Z])/g, '$1_$2').toLowerCase()
      params[param] = value
    })

    const result = await api.get<GetLogsResponse>('/logs', {
      params,
    })

    const { data } = result

    return data
  } catch (err) {
    if (err instanceof AxiosError) {
      console.error(err.message)
    }
    return {
      logs: [],
      pageQty: 0,
      totalCount: 0,
    }
  }
}
